import React from 'react';
import { deadlineIcon } from '../../../constants/icons';
import avatar from '../../../../assets/img/sample.png';

export default function MyActivities({className, logs}) {
  return (
    // Todo: need to add pagination condition for audit logs
    <div className={`${className || ''} activities-content myk__stu-doc-activity-logs`}>
      <ul className="activity-content-list">
        {logs && logs.audit_log && logs.audit_log.map((log, index) => (
          <li key={index}>
            <div className={`icon-wrap`}>
                {/* <img src={activity.icon} alt="User Avatar" className="img-fluid"/> */}
            </div>
            <div className="info-wrap">
              <h4>
                <span dangerouslySetInnerHTML={{__html: log.la_message}}></span>
              </h4>
              <div className="date-wrap">
                {deadlineIcon}
                <span>{log.la_created_date}</span>
                {/* need to convert into date time */}
              </div>
              <div className='date-wrap'> 
                <span>{log.la_user_email}</span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
